import { isAdmin } from "../../../../shared/components/layout/sidebar/utils/permissions.js";

const MASTER_ROLE_TOKEN = "master";

/** Decide se o usuário define e vê a comissão do vendedor: Admin, ou Master com inserção/listagem. */
export function canManageSellerCommission(permissions) {
  const roles = Array.isArray(permissions) ? permissions : [];
  return isAdmin(roles) || roles.some(isMasterWithInsertOrList);
}

function isMasterWithInsertOrList(role) {
  if (!role?.isinsert && !role?.islist) {
    return false;
  }
  return toRoleToken(role) === MASTER_ROLE_TOKEN;
}

function toRoleToken(role) {
  return String(role?.role_code ?? role?.roleCode ?? role?.name ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .replace(/[ -]+/g, "_")
    .toLowerCase();
}
